import React from "react";
import { Building2 } from "lucide-react";
import { motion } from "framer-motion";
import partnersLogo from "../../../public/partnersLogo.png"

const partners = [
  {
    id: "mevka",
    name: "Mevlana Kalkınma Ajansı",
    shortName: "MEVKA",
    // role: "Ana Destekçi",
    description: "Bölgesel kalkınma ve inovasyon ekosisteminin güçlü destekçisi",
  },
  {
    id: "konya-bb",
    name: "Konya Büyükşehir Belediyesi",
    shortName: "Konya BB",
    // role: "Kurumsal Ortak",
    description: "Konya'nın teknoloji ve girişimcilik vizyonunu taşıyan stratejik ortak",
  },
];

export const PartnersSection: React.FC = () => {
  return (
    <section id="sponsors" className="px-4 sm:px-6 lg:px-10 py-14 sm:py-16 sm:mb-16 bg-[var(--bg-primary)]">
      <div className="max-w-7xl mx-auto">
        <div className="mb-14 text-center">
          <h2 className="text-4xl sm:text-5xl font-black text-[var(--text-primary)] mb-4">
            Kurumsal İş Birlikleri
          </h2>
          <div className="w-24 h-1 mx-auto rounded-full bg-[#73E03A]" />
        </div>

        <div className="flex flex-col sm:flex-row justify-center gap-4 max-w-2xl mx-auto">
          {partners.map((partner, idx) => (
            <motion.div
              key={partner.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              whileHover={{ y: -6, scale: 1.02 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.08, type: "spring", stiffness: 220, damping: 18 }}
              className="kapsul-card p-6 text-center flex-1 relative overflow-hidden"
              style={{ borderColor: "rgba(115,224,58,0.35)" }}
            >
              <div className="absolute inset-x-0 top-0 h-1.5 bg-[#73E03A]" />
              <Building2 className="mx-auto h-7 w-7 text-[#57B92B]" />
              <p className="mt-3 font-black text-[var(--text-primary)]">{partner.name}</p>
              <p className="text-sm text-[var(--text-secondary)] mt-2 leading-relaxed">
                {partner.description}
              </p>
            </motion.div>
          ))}
          
        </div>
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="mt-10 flex justify-center"
        >
          <img
            src="/partnersLogo.png"
            alt="Paydaş kurumlar"
            className="w-full max-w-5xl object-contain opacity-90"
          />
        </motion.div>
      </div>
    </section>
  );
};